import { SET_USER_DATA_FOR_BANNER } from '../actions/types';

const initialState = {
    cache_time: 0
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_USER_DATA_FOR_BANNER:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}